import DefaultEarthComponent from './index.vue'

const DefaultEarth = {
  install: function(Vue) {
    Vue.component('DefaultEarth', DefaultEarthComponent)
  }
}

export default DefaultEarth



// WEBPACK FOOTER //
// ./src/components/defaultEarth/index.js